<form  nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="name" nzRequired #label>Tên nhãn</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="name" name="name" type="text" placeholder="Nhập tên nhãn">
      </nz-form-control>
      </nz-form-item >
    </div>
    <div nz-col nzSm="24" nzMd="24" class="select-color">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="color">Màu sắc</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn màu sắc" formControlName="color" [nzCustomTemplate]="templateSelect">
            <nz-option *ngFor="let color of colors" [nzValue]="color" nzCustomContent>
              <div class="color-tag" [style.background]="color">
              </div>
            </nz-option>
          </nz-select>
          <ng-template #templateSelect let-selected>
            <div class="color-tag" [style.background]="selected.nzValue">
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item >
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button (click)="close()">Đóng</button>
    <button nz-button *ngIf="mode === 'add'" (click)="add()" [nzSize]="'large'" nzType="primary">
      Thêm
      <i nz-icon nzType="save" nzTheme="outline"></i>
    </button>
    <button nz-button *ngIf="mode === 'edit'" (click)="edit()" [nzSize]="'large'" nzType="primary">
      Sửa
      <i nz-icon nzType="save" nzTheme="outline"></i>
    </button>
  </div>
</form>